import { useWatch } from "react-hook-form";
import { useProductsByIds } from "../../../services/productsService";

/**
 * Use within form provider
 */
export const useIsOfferFormDataValid = (fields) => {
    const selectedCustomerIds = useWatch({ name: fields.customerIds });
    const discounts = useWatch({ name: fields.discount });
    const selectedProductIds = Object.keys(discounts);
    const { isLoading, data: selectedProducts } = useProductsByIds(selectedProductIds);

    const isAtLeastOneCustomerSelected = selectedCustomerIds?.length > 0;
    const isAtLeastOneApartmentSelected =
        selectedProductIds.length > 0 &&
        !isLoading &&
        selectedProducts != null &&
        selectedProducts.some((p) => p.is_apartment);

    const isValid = isAtLeastOneCustomerSelected && isAtLeastOneApartmentSelected;

    return {
        isValid,
        isCustomersValid: isAtLeastOneCustomerSelected,
        isProductsValid: isAtLeastOneApartmentSelected,
    };
};
